<div class="content-container">

  <div>

    <h1 class="center"
        [anessaTranslation]="getHeaderTranslationID()">
    </h1>

    <div *ngIf="invalidScenariosArePresent" class="invalid-scenarios-section">
      <h3 anessaTranslation="SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.INVALID_SCENARIOS_HEADER"></h3>
      <span [anessaTranslation]="getInvalidScenariosDescription()"></span>

      <div class="invalid-scenarios-container" *ngFor="let scenario of invalidScenariosMap| keyvalue">

        <div class="flex-container flex-align-item-center">
          <mat-icon class="invalid-icon">error</mat-icon>
          <h4>{{ scenario.key }}</h4>
        </div>

        <div *ngFor="let input of scenario.value">

          <div class="invalid-scenario-input flex-container flex-align-item-center">
            <mat-icon class="invalid-icon">error</mat-icon>
            <span>{{ input }}</span>
          </div>

        </div>

      </div>
    </div>

    <div *ngIf="affectedScenariosArePresent" class="affected-inputs-section">
      <h3 anessaTranslation="SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.AFFECTED_SCENARIOS_HEADER"></h3>
      <span [anessaTranslation]="getAffectedScenariosDescription()"></span>

      <div class="affected-inputs-container" *ngFor="let scenario of affectedScenariosMap | keyvalue">

        <div class="flex-container flex-align-item-center">
          <mat-icon class="warning-icon">warning</mat-icon>
          <h4>{{ scenario.key }}</h4>
        </div>


        <mat-table id="affectedScenarioTable" [dataSource]="scenario.value">

          <ng-container [matColumnDef]="inputHeader">
            <mat-header-cell id="ast-name-header-cell"
                             *matHeaderCellDef [anessaTranslation]="headerTranslations[inputHeader]">
            </mat-header-cell>
            <mat-cell id="ast-name-cell" *matCellDef="let input">
              <ng-container *ngIf="input">
                <div [innerHTML]="input['name']"></div>
              </ng-container>
            </mat-cell>
          </ng-container>

          <ng-container [matColumnDef]="originalValueHeader">
            <mat-header-cell
              *matHeaderCellDef [anessaTranslation]="headerTranslations[originalValueHeader]">
            </mat-header-cell>
            <mat-cell *matCellDef="let input">
              <div [innerHTML]="input['originalValue']"></div>
            </mat-cell>
          </ng-container>

          <ng-container [matColumnDef]="updatedValueHeader">
            <mat-header-cell
              *matHeaderCellDef [anessaTranslation]="headerTranslations[updatedValueHeader]">
            </mat-header-cell>
            <mat-cell *matCellDef="let input">
              <div [innerHTML]="input['updatedValue']"></div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="headers"></mat-header-row>
          <mat-row *matRowDef="let row; columns: headers;"></mat-row>

        </mat-table>
      </div>
    </div>


  </div>
  <hr class="button-separator-line">
  <div class="compact-button-group bottom-button-group">
    <button id="ack-and-keep-btn"
            class="btn-compact"
            mat-button
            type="button"
            [matTooltip]="keepInvalidScenariosTooltip"
            (click)="(invalidScenariosArePresent) ? acknowledgeAndKeepScenarios(): acknowledge()"
    > {{ ackAndKeepBtnText }}
    </button>
    <button *ngIf="invalidScenariosArePresent"
            id="ack-and-delete-btn"
            class="btn-compact"
            mat-button
            type="button"
            [matTooltip]="deleteInvalidScenariosTooltip"
            (click)="acknowledgeAndDeleteScenarios()"
    >{{ ackAndDeleteBtnText }}
    </button>
  </div>
  <div *ngIf="invalidScenariosArePresent" class="scenario-simulation-info-container">
    <p anessaTranslation="SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.SCENARIO_SIMULATION_INFO"></p>
  </div>
  <div class="skip-cancel-btn-group">
    <button id="skip-and-proceed-btn"
            *ngIf="!isScenarioSimulation"
            class="btn-green"
            mat-button
            type="button"
            (click)="onSkipAndProceedClick()"
            anessaTranslation="SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.BUTTONS.SKIP_AND_PROCEED"
    ></button>
    <button id="cancel-btn"
            class="btn-red"
            mat-button
            type="button"
            (click)="onCancelClick()"
            anessaTranslation="COMMON.CANCEL"
    ></button>

  </div>
</div>
